import React from "react";
import { useEffect, useState } from "react";
import { Box, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useParams, useLocation, useNavigate } from "react-router-dom";

import CustomizedAccordions from "../../components/homepage/accordion";
import ContentCards from "../../components/homepage/contentCards";
import CustomContainer from "../../components/layout/container";
import CustomHeader from "../../components/layout/header";

import MissanLogo from "../../images/Missan_Oil_Company_Logo.png";
// import iDEAvideoGame from "../../images/iDEA_VideoGames.jpg"
import SheikhClass from "../../images/Sheikh_Classroom.jpg" ;
import FeedbackFaces from "../../images/FeedbackFaces_Red.jpg" ;

const MissanOilCaseStudy = () => {
  // const router = useNavigate();
  // const { MissanOil } = useParams();

  const [pageTitle, setPageTitle] = useState("");
  const [borderColorToHighlight, setborderColorToHighlight] =
    useState("why/case-study/MissanOil");

  const breadcrumbData = [
    { name: "Home", link: "/" },
    {
      name: `Case Study (MissanOil)`,
      link: `/why/case-study/MissanOil`,
    },
  ];

  return (
    <Box>
      <Grid>
        <title>{pageTitle?.toUpperCase()} | MEF</title>
        <meta
          name="description"
          content="Identify & Quantify Macroeconomic/Esg risk"
        />
      </Grid>
      <CustomHeader
        title={"Client Case Study-Executive Education/Training"}
        breadcrumbData={breadcrumbData}
      />

      <CustomContainer>
        <Box >
          <Grid container spacing={1.5}>
            <Grid item xs={12} sm={6} md={4}>
              <ContentCards
                imgSrc={MissanLogo}
                title="Client Profile - National Energy Company"
                objectFit="contain"
                subTitle="Engaging Foreign Companies for Co-Development"
                //example to link in text
                body={`Missan Oil Company (MOC) is a state-owned oil and gas company located in the Maysan Governorate, Iraq. The headquarters are located in the capital of the province, Amarah `}
              />
              <CustomizedAccordions
                title="MOC Background"
                body={`Missan was spun off from South Oil Company in 2008 to expand oil activities in Maysan and to set up and oversee joint ventures with international companies to develop the province's oil fields:
              `}
/>
              <CustomizedAccordions
                title="Assisting MOC "
                body={`In its mission to engage overseas firms & specialists to develop national Energy assets, the management function at MOC needed to
                  evolve to a more multinational basis. Rather than just 'import' some broader management perspectives & techniques, this required MOC 
                  senior managers to develop a deeper, organic grasp of both organisational development as well as a wider, Global perspective Economic/Energy developments.
                  Avoiding large CAPEX committments in long-lived energy infrastructure assets that could quikcly become 'stranded' was the strategic aim of such
                  broadening of MOC management perspective`}
              />

            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <ContentCards
                imgSrc={SheikhClass}
                title="Client Needs-Bespoke Management Training"
                objectFit="contain"
                subTitle={`How MEF Assisted designing suitable Executive Education`}
                body={`<p>Whilst the broad training goals were reasonably clear, this still leaves the issue of tailoring a custom UK rolling program for an Iraq-based
                  management cadre. In discussion with both MOC, their intermediary (ResModTec) and Alliance Manchester Business School (AMBS) ExecEd team, MEF crafted material which 'set the scene' of the
                  quickly evolving renewable energy build-out. In particular this focused on the likely <i>timeframes</i> of Energy decarbonisation and the 
                  imminent implications for all Energy companies. It then moved to the evolving landscape of (European) ESG regulation despite the more recent pushback
                  in the US with the re-election of Donald Trump.
                   </p>`}
              />
              <CustomizedAccordions
                title="Training Unit Details"
                body={`The 3 week management training program - which was repeated over 9 Senior Management cohorts - comprised the following units:</u>
                  <ul>
                      <li><u>Leadership in Practice</u> – personal attributes & preferences</li>
                      <li><u>Strategy, Innovation and Leadership</u> - bringing strategy and innovation to life </li>
                      <li><u>The Big Issues</u> - big Data, data analytics, predictions, preferences and recommendations</li>
                      <li><u>Supply Chains</u> -continuity, contingency planning and economic shocks</li>
                      <b><li><u>ESG & Energy Transformation</u> - ESG metrics, regulations & the Impending Energy Disruption &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; [MEF-delivered]</li></b>
                      <li><u>Negotiation skills</u> - plan/prep for negotiation RE: international regulatory environments. </li>
                      </ul>	
                      <br><br>
                `}
              />
              {/* <CustomizedAccordions
                title="[   ] ]Scenario Analysis; using mGEM Scenario Drivers "
                body="Once deployed, MissanOil commission MEF to “stress-test” official (ie OBR, OECD, IMF) Budget projections with plausible global macro scenarios to capture & quantify 
                domain-level uncertainty around central projections; these are then fed-through to ..."
              /> */}
              {/* Download not working ! + need .PDF icon
              <a href="./public/downloads/MEF_iDEA_CaseStudy.pdf">    <button>Case Study .PDF</button> </a>  */}
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <ContentCards
                imgSrc={FeedbackFaces}
                title="Client Feedback"
                objectFit="contain"
                subTitle={`On successful conclusion of the training program, Hussain Abou Sayed of ResModTec commented:`}
                 body={`<i>ResModTec is proud to announce the successful completion of 6 cohorts for the  Leadership & Management Development Program, delivered in collaboration
                      with Alliance Manchester Business School. This intensive three-week program was designed for top executives and managers at Missan Oil Company (MOC) in
                      Missan, Iraq. The initiative aimed to enhance leadership and management capabilities, and empower MOC’s senior leaders with the skills needed to drive
                      future success in the ...sector.</i><br><br>
                <hr style="color:#00a0a0;height:1px;width:50%;">
                If you would like to initiate an informal chat about how MEF's modelling and/or scenario services may augment your risk analysis, please email us
                at: <b style="color:#00a0a0" > bespoke@mef-uk.com </u> `}
              />
            </Grid>
          </Grid>
        </Box>
      </CustomContainer>
    </Box>
  );
};

export default MissanOilCaseStudy;
// IDEACaseStudy.getInitialProps = async ({ whyData }: any) => {
//   return whyData;
// };
